import React, { memo } from 'react';

import { loginStyles } from '@constants/mui-theme';

import { Link } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';

import './layouts/not-authenticated/not-authenticated.scss';
import styles from './invalid.scss';
import UnstyledHeading from '@components/shared/unstyled-heading';

const INVALID_AUTH_HEADER_ID = 'auth-invalid-heading';

const InvalidAuth = () => {
  return (
    <div styleName="not-authenticated-container">
      <main className={styles.container} aria-labelledby={INVALID_AUTH_HEADER_ID}>
        <ErrorOutlineIcon
          classes={{root: styles.icon}}
        />
        <UnstyledHeading rank={2} id={INVALID_AUTH_HEADER_ID} styleName="auth-heading">Link expired</UnstyledHeading>
        <div styleName="auth-section">
          The link you clicked has either expired or invalid.
        </div>
        <div styleName="auth-section">
          <div styleName="link-text">
            <Link style={loginStyles.links} to={'/login'}>Login</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default memo(InvalidAuth);
